import { render, staticRenderFns } from "./CohortsCard.vue?vue&type=template&id=38ec58be&scoped=true"
import script from "./CohortsCard.vue?vue&type=script&lang=js"
export * from "./CohortsCard.vue?vue&type=script&lang=js"
import style0 from "./CohortsCard.vue?vue&type=style&index=0&id=38ec58be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ec58be",
  null
  
)

export default component.exports